const SexoEnum = {
  M: 'Masculino',
  F: 'Feminino',
  I: 'Ignorado',
};

export default SexoEnum;
